module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp12_8019.ce89c423.png";